require('./dropdownPopoverController');
require('./uiAutoClosePopover');

/*@ngInject*/
const DropdownPopoverDirective = function ($timeout, $window) {

    const linkFunction = function ($scope, $elm, $attr, $controller, $transclude) {

        const requestAnimationFrame = $window.requestAnimationFrame || $window.mozRequestAnimationFrame || $window.webkitRequestAnimationFrame || $window.msRequestAnimationFrame;
        const cancelAnimationFrame = $window.cancelAnimationFrame || $window.mozCancelAnimationFrame;

        const element = $elm[0];

        let popoverMenu;
        let transcludeScope;
        let animationFrameRequest = null;

        $elm.addClass('umDropdownPopoverComponent');

        $transclude(function (cloneList, scope) {
            const transcludeContainer = document.createElement('div');
            transcludeContainer.classList.add('umPopover');

            if (_.includes($scope.popoverClassName, ' ')) {
                _.each(_.split($scope.popoverClassName, ' '), function (className) {
                    transcludeContainer.classList.add(className);
                });
            } else {
                transcludeContainer.classList.add($scope.popoverClassName);
            }


            if (!_.isEmpty($scope.popoverIdentifier)) {
                transcludeContainer.classList.add($scope.popoverIdentifier);
            }

            _.each(cloneList, (clone) => {
                transcludeContainer.appendChild(clone);
            });

            document.body.appendChild(transcludeContainer);
            popoverMenu = transcludeContainer;
            transcludeScope = scope;

            animationFrameRequest = requestAnimationFrame(calculatePopoverPosition);
        });

        function calculatePopoverPosition() {
            // TODO need to optimize this so it doesn't run so frequently.

            const windowHeight = Math.max(document.documentElement.clientHeight, $window.innerHeight || 0);

            const headerHeight = 60;
            const searchComponentHeight = 58;
            const clearSelectedHeight = 33;
            const maxWidth = 600;
            const displayAreaHeight = windowHeight - headerHeight;

            const popoverMenuRect = popoverMenu.getBoundingClientRect();
            const popoverMenuHeight = Math.round(parseFloat(popoverMenuRect.height));

            const elementRect = element.getBoundingClientRect();
            const elementTop = Math.round(parseFloat(elementRect.top));
            const elementHeight = Math.round(parseFloat(element.offsetTop));
            const elementLeft = Math.round(parseFloat(elementRect.left));
            const elementWidth = Math.round(parseFloat(elementRect.width));

            let targetTop = elementTop;

            const openUp = elementTop - (elementHeight * 2) > displayAreaHeight / 2;

            if (openUp) {
                targetTop = elementTop - (elementHeight + popoverMenuHeight);

                if (targetTop < headerHeight) {
                    const dropdownList = $(popoverMenu).find('um-dropdown-list');
                    const dropdownListHeight = dropdownList.height();
                    const newHeight = dropdownListHeight + targetTop - headerHeight - 5;
                    dropdownList.css('max-height', newHeight);
                    targetTop = headerHeight + 5;
                }
            } else {
                const dropdownList = $(popoverMenu).find('um-dropdown-list');
                const dropdownListHeight = dropdownList.height();
                if (targetTop + dropdownListHeight > windowHeight) {
                    let newHeight = windowHeight - targetTop - searchComponentHeight;
                    const clearSelectedButton = $(popoverMenu).find('.clearSelectedButton');

                    if (clearSelectedButton.length !== 0) {
                        newHeight -= clearSelectedHeight;
                    }

                    dropdownList.css('max-height', newHeight);
                }
            }

            popoverMenu.style.left = elementLeft + 'px';
            popoverMenu.style.top = targetTop + 'px';
            popoverMenu.style['min-width'] = _.clamp(elementWidth, 0, maxWidth) + 'px';

            animationFrameRequest = requestAnimationFrame(calculatePopoverPosition);
        }

        $scope.$on('$destroy', () => {
            $(popoverMenu).remove();  // TODO fix this properly: https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
            transcludeScope.$destroy();

            if (animationFrameRequest) {
                cancelAnimationFrame(animationFrameRequest);
            }
        });
    };

    return {
        link: linkFunction,
        restrict: 'E',
        transclude: true,
        controller: 'umDropdownPopoverController',
        scope: {
            visible: '<',
            popoverIdentifier: '@',
            popoverClassName: '@'
        }
    };
};

angular.module('umCore')
    .directive('umDropdownPopover', DropdownPopoverDirective);
